module.exports = __webpack_public_path__ + "static/media/pe.4fb8c006.svg";